import React from 'react'

const DownCaratIcon = () => (
  <svg width="14" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M.512 3.153L7 10l6.489-6.847a1.924 1.924 0 000-2.612 1.689 1.689 0 00-2.476 0L7 4.776 2.987.541C2.656.19 2.217 0 1.749 0 1.282 0 .843.192.512.54a1.922 1.922 0 000 2.613z" fill="#FFF" fillRule="nonzero"/></svg>
)

export default DownCaratIcon

